export default __webpack_public_path__ + "static/media/s1_female.d233c9cc.wav";